import { useTheme } from '@material-ui/core';
import { useEffect, useState } from 'react';
import '../lib/pin_hosted_fields.v1';
import { isObee } from './constants';

export const usePinPayments = (pinMode) => {
  const theme = useTheme();
  // const pinPaymentFields = useRef();
  const [pinPaymentFields, setPinPaymentFields] = useState(null);

  const onLoad = () => {
    setPinPaymentFields(
      window.HostedFields.create({
        // Set this to true when testing. Set it to false in production.
        sandbox: pinMode === 'test',
        // Optional: set autocomplete to true to allow web browsers to suggest saved credit cards.
        autocomplete: true,

        // These are the CSS styles for the input elements inside the iframes. Inside each iframe is a single input with its id set to name, number, cvc or expiry.
        // When the input has a valid value, it will have the 'hosted-fields-valid' class. When the input has an invalid value, it will have the 'hosted-fields-invalid' class.
        styles: {
          input: {
            'font-family': `${theme.baseTypography.numberFontFamily},'Inter', 'Open Sans', 'Helvetica', 'sans-serif' !important`,
            'font-size': '15px',
            height: '48px',
            // color: '#3a3a3a',
            color: theme.colors.mainTextColour,
            // 'background-color': theme.colors.inputFieldsBackground,
            'background-color':
              theme.colors.availabilityBackgroundBoxBgColour ||
              (theme.colors.darkMode ? theme.colors.charcoal : theme.colors.white),
            padding: '0px 12px',
          },
          'input:focus': {
            // 'background-color': 'transparent !important',
            outline: `1px solid ${theme.colors.activeOutlineColour}`,
            'background-color':
              theme.colors.availabilityBackgroundBoxBgColour ||
              (theme.colors.darkMode ? theme.colors.charcoal : theme.colors.white),
          },
          '.hosted-fields-invalid:not(:focus)': {
            'font-family': `${theme.baseTypography.numberFontFamily}, 'Inter', 'Open Sans', 'Helvetica', 'sans-serif' !important`,
            color: 'red',
          },
          '.pin-form-field': {
            height: '48px',
            border: '1px solid black',
          },
          'input::placeholder': {
            'font-family': `${theme.baseTypography.numberFontFamily}, 'Inter', 'Open Sans', 'Helvetica', 'sans-serif' !important`,
            color: theme.colors.secondaryTextColour ?? 'inherit',
          },
        },

        // The fields object defines the fields to be created. All four fields are required (name, number, cvc, expiry).
        // Each field requires a selector for the element in which to create an iframe. Optionally, you can define placeholder text and a label selector (the CSS selector of the label element for that particular field).
        fields: {
          name: {
            selector: '#name',
            placeholder: 'Name on card',
          },
          number: {
            selector: '#number',
            // placeholder: '4200 0000 0000 0000',
            placeholder: 'Card number',
          },
          cvc: {
            selector: '#cvc',
            // placeholder: '123',
            placeholder: 'CVV',
          },
          expiry: {
            selector: '#expiry',
            placeholder: 'MM/YY',
            // placeholder: 'Empty',
          },
        },
      }),
    );
  };

  useEffect(() => {
    if (!pinPaymentFields && isObee) {
      onLoad();
    }
  }, []);

  return pinPaymentFields;
};
